{
  "common": {
    "cancel": "Cancelar",
    "save": "Guardar",
    "delete": "Eliminar",
    "edit": "Editar",
    "done": "Listo",
    "loading": "Cargando...",
    "syncing": "Sincronizando...",
    "error": "Error",
    "success": "Exitoso",
    "retry": "Reintentar",
    "share": "Compartir",
    "join": "Unirse",
    "by": "por"
  },
  "auth": {
    "signIn": "Iniciar sesion",
    "signUp": "Registrarse",
    "signOut": "Cerrar sesion",
    "signInRequired": "Inicio de sesion requerido",
    "signInDescription": "Por favor inicia sesion para continuar con esta accion",
    "continueWithGoogle": "Continuar con Google",
    "continueWithApple": "Continuar con Apple",
    "welcomeBack": "Bienvenido de nuevo!",
    "createAccount": "Crea una cuenta para comenzar"
  },
  "tabs": {
    "home": "Inicio",
    "zones": "Zonas",
    "create": "Crear",
    "profile": "Perfil",
    "settings": "Ajustes"
  },
  "settings": {
    "title": "Ajustes",
    "appearance": "Apariencia",
    "theme": "Tema",
    "themeLight": "Claro",
    "themeDark": "Oscuro",
    "themeSystem": "Sistema",
    "language": "Idioma",
    "languageEnglish": "Ingles",
    "languageSpanish": "Espanol"
  },
  "post": {
    "title": "Titulo",
    "titlePlaceholder": "Un titulo interesante",
    "body": "Contenido",
    "bodyPlaceholder": "Escribe tu publicacion aqui...",
    "selectZone": "Selecciona una zona",
    "postTo": "Publicar en",
    "posting": "Publicando...",
    "post": "Publicar",
    "deletePost": "Eliminar publicacion",
    "deleteConfirm": "Estas seguro de que quieres eliminar esta publicacion?",
    "deleteWarning": "Esta accion no se puede deshacer. Estas seguro de que quieres eliminar permanentemente esta publicacion?",
    "options": "Opciones de publicacion",
    "addLink": "Agregar Enlace",
    "linkPlaceholder": "Pega un enlace de YouTube, X (Twitter), u otro",
    "linkHint": "Soportados: YouTube, X (Twitter), y enlaces directos",
    "comments": "comentarios",
    "noComments": "Sin comentarios aun",
    "addComment": "Agregar un comentario",
    "reply": "Responder",
    "showReplies": "Mostrar respuestas",
    "hideReplies": "Ocultar respuestas",
    "upvote": "Votar a favor",
    "downvote": "Votar en contra",
    "maxImages": "Maximo {{count}} imagenes permitidas",
    "videoSelected": "Video seleccionado",
    "compressingVideo": "Comprimiendo video...",
    "videoReady": "Video listo",
    "loadingCompressor": "Cargando compresor...",
    "finalizingVideo": "Finalizando...",
    "compressing": "Comprimiendo",
    "uploadingVideo": "Subiendo video"
  },
  "zone": {
    "search": "Buscar zonas",
    "noZones": "No se encontraron zonas",
    "members": "miembros",
    "member": "miembro",
    "createZone": "Crear Zona",
    "zoneName": "Nombre de la Zona",
    "zoneNamePlaceholder": "Ingresa el nombre de la zona",
    "zoneDescription": "Descripcion",
    "zoneDescriptionPlaceholder": "De que trata esta zona?",
    "creating": "Creando...",
    "create": "Crear",
    "allTopics": "Todos los Temas",
    "selectType": "Tipo de Zona",
    "selectTopics": "Temas",
    "posts": "Publicaciones",
    "about": "Acerca de",
    "joined": "Unido",
    "leave": "Salir",
    "online": "En linea",
    "offline": "Desconectado",
    "players": "jugadores",
    "recruiting": "Reclutando",
    "notRecruiting": "No Reclutando",
    "types": {
      "general": "General",
      "server": "Servidor",
      "project": "Proyecto",
      "guild": "Gremio",
      "feedback": "Sugerencias"
    },
    "typeDescriptions": {
      "general": "Discusiones, memes, arte, historia",
      "server": "Comunidad de servidor multijugador",
      "project": "Mods y creaciones",
      "guild": "Grupos y clanes de jugadores",
      "feedback": "Reportes de errores y sugerencias"
    },
    "serverFields": {
      "serverIp": "IP del Servidor",
      "serverPort": "Puerto",
      "region": "Region",
      "status": "Estado",
      "modsUsed": "Mods Usados"
    },
    "projectFields": {
      "version": "Version",
      "downloadUrl": "Descargar",
      "repositoryUrl": "Repositorio",
      "compatibility": "Compatibilidad"
    },
    "guildFields": {
      "recruiting": "Reclutando",
      "discordUrl": "Discord",
      "roster": "Lista de Miembros"
    },
    "topics": {
      "adventure": "Aventura",
      "building": "Construccion",
      "combat": "Combate",
      "creative": "Creativo",
      "minigames": "Minijuegos",
      "modding": "Modding",
      "pvp": "PvP",
      "roleplay": "Roleplay",
      "survival": "Supervivencia",
      "trading": "Comercio",
      "tutorials": "Tutoriales",
      "news": "Noticias",
      "art": "Arte",
      "memes": "Memes",
      "lore": "Historia",
      "technical": "Tecnico"
    }
  },
  "errors": {
    "loadFailed": "Error al cargar datos",
    "postFailed": "Error al crear publicacion",
    "commentFailed": "Error al agregar comentario",
    "deleteFailed": "Error al eliminar",
    "signInFailed": "Error al iniciar sesion. Por favor intenta de nuevo.",
    "saveFailed": "Error al guardar. Por favor intenta de nuevo."
  },
  "username": {
    "setupTitle": "Elige tu nombre de usuario",
    "setupDescription": "Tu nombre de usuario es como otros te encontraran y mencionaran. Se usara para la URL de tu perfil.",
    "changeTitle": "Cambiar nombre de usuario",
    "changeDescription": "Puedes cambiar tu nombre de usuario una vez cada 30 dias.",
    "placeholder": "nombre_usuario",
    "hint": "3-20 caracteres. Solo letras, numeros y guiones bajos.",
    "taken": "Este nombre de usuario ya esta en uso",
    "continue": "Continuar",
    "cooldownTitle": "Tiempo de Espera para Cambiar Nombre",
    "cooldownMessage": "Puedes cambiar tu nombre de usuario en {{days}}"
  },
  "empty": {
    "noPosts": "No hay publicaciones aun",
    "beFirst": "Se el primero en compartir algo!"
  },
  "home": {
    "newPostsAvailable": "Nuevas publicaciones disponibles"
  },
  "profile": {
    "title": "Perfil",
    "editProfile": "Editar Perfil",
    "karma": "Karma",
    "posts": "Publicaciones",
    "memberSince": "Miembro desde",
    "noPosts": "Sin publicaciones aun",
    "createFirstPost": "Crea tu primera publicacion!",
    "yourPosts": "Tus Publicaciones"
  }
}
